module.exports = __webpack_public_path__ + "media/WeChat_20211012163527.418b7595.mp4";